import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { doc, setDoc, arrayUnion } from "firebase/firestore";
import { db } from "./firebase";

// The set of pages the "Page Explorer" badge (issue #166) requires visiting.
// Deliberately excludes: admin-only pages (fans can't reach them), account-
// type-specific pages like /fan-account vs /artist-account (a fan would
// otherwise need to become an artist to finish the set), signup/login/
// callback flows (one-time, not "pages" to explore), and dynamic
// per-artist/per-fan routes (/artist/:name, /fan/:uid - unbounded, "visit
// every artist page" isn't a sane badge). What's left is every static page
// open to any signed-in visitor regardless of account type.
//
// Mirrored in Backend/services/badge_service.py's PAGE_EXPLORER_PAGES -
// keep the two lists in sync if either changes (same cross-file mirroring
// routes/artists.py:get_vote_doc_id already does with the frontend).
export const TRACKED_PAGES = [
  "/",
  "/heatmap",
  "/discover",
  "/fan-leaderboard",
  "/shop",
  "/help",
  "/about",
  "/copyright",
];

// Renders nothing - just watches route changes and records visited pages
// on the signed-in user's own doc, the same arrayUnion pattern already used
// for followedFans/bookmarkedArtists. setDoc(merge:true) rather than
// updateDoc(): updateDoc 404s if the users/{uid} doc doesn't exist yet,
// which is possible right after signup (see fan.py's profile-picture route
// for the same reasoning).
function PageViewTracker({ user }) {
  const location = useLocation();

  useEffect(() => {
    if (!user) return;
    const path = location.pathname === "/nexxup" ? "/" : location.pathname;
    if (!TRACKED_PAGES.includes(path)) return;

    setDoc(doc(db, "users", user.uid), { visitedPages: arrayUnion(path) }, { merge: true }).catch(
      (err) => console.error("Error recording page view:", err)
    );
  }, [location.pathname, user]);

  return null;
}

export default PageViewTracker;
